import styled from "styled-components";
import { FaWallet, FaMoneyBillWave, FaUsers, FaUserTimes, FaBalanceScale, FaPlusCircle } from 'react-icons/fa';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    PieChart, Pie, Cell, ResponsiveContainer
  } from "recharts";

const Section = styled.section`
    padding-left: 60px;
    min-height: 100vh;
    min-width: 100vw;
    
    @media (max-width: 1180px) {
        padding-left: 0;
        padding-bottom: 3rem;
    }
`
const Nav = styled.div`
    width: 100%;
    padding: 15px;
`
const DivContent = styled.div`
`
const Box = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 30px 15px;
    border-radius: 20px;
    box-shadow: 0 3px 6px #00000029;
    background-color: #E28C19;
`
const Icon = styled.div`
    display: inline-block;
    margin-right: 15px;
    padding: 10px;
    border-radius: 5px;

    &.wallet {
        background-color: #34A275;
    }
    &.FaMoneyBillWave {
        background-color: #0C2374;
    }
    &.FaUserTimes {
        background-color: #F85156;
    }
    &.FaBalanceScale,
    &.FaUsers {
        background-color: #174D1A;
    }
`
const Desc = styled.div`
    display: inline-block;
`
const Title = styled.span`
    display: block;
    font-size: 15px;
    color: #fff;
`
const Text = styled.strong`
    font-size: 20px;
    color: #fff;
    display: block;
`
const FinanceContent = styled.div`
    width: 100%;
    padding: 15px;
`
const AddPay = styled.div`
    background-color: #183602;
    padding: 60px 15px;
    border-radius: 20px;
    box-shadow: 0 3px 6px #00000029;    
    text-align: center;
    `
const Button = styled.button`
    border: none;
    background-color: #18501C;
    color: #fff;
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0 3px 6px #00000029;    
    font-size: 20px;

    svg {
        margin-right: 15px;
    }
    &:focus{
        outline: none;
    }
`
const GraphSection = styled.div`
`
const GrahpBox = styled.div`
`
const GrahpContent = styled.div`
    padding: 30px;
    border-radius: 20px;
    background-color: #192135;
    box-shadow: 0 3px 6px #00000029; 
`
const barData = [
    { name: 'Jan', Pagantes: 22, NaoPagantes: 10 },
    { name: 'Feb', Pagantes: 28, NaoPagantes: 14 },
    { name: 'Mar', Pagantes: 35, NaoPagantes: 15 },
    { name: 'Apr', Pagantes: 26, NaoPagantes: 12 },
    { name: 'Jul', Pagantes: 30, NaoPagantes: 11 },
  ];
  
const pieData = [
    { name: 'Pagos', value: 75 },
    { name: 'Pendentes', value: 25 },
];

const COLORS = ['#1976d2', '#e53935']; // Verde, Azul

function FinanceSection(){
    return(
        <Section>
            <Nav className="row m-0 mt-4 pb-4">
                <DivContent className="col-12 col-lg-3 mb-4 mb-lg-0">
                    <Box>
                        <Icon className="wallet">
                            <FaWallet color="#fff" size={24}/>
                        </Icon>
                        <Desc>
                            <Title>Total em caixa:</Title>
                            <Text>R$ 2.500,00</Text>
                        </Desc>
                    </Box>
                </DivContent>
                <DivContent className="col-12 col-lg-3 mb-4 mb-lg-0">
                    <Box>
                        <Icon className="FaMoneyBillWave">
                            <FaMoneyBillWave color="#fff" size={24}/>
                        </Icon>
                        <Desc>
                            <Title>Valor mensal Da Quadra:</Title>
                            <Text>R$ 600,00</Text>
                        </Desc>
                    </Box>
                </DivContent>
                <DivContent className="col-12 col-lg-6">
                    <Box>
                        <Icon className="FaBalanceScale">
                            <FaBalanceScale color="#fff" size={24}/>
                        </Icon>
                        <Desc>
                            <Title>Saldo:</Title>
                            <Text>R$ 1.900,00</Text>
                        </Desc>
                    </Box>
                </DivContent>
            </Nav>
            <FinanceContent className="row m-0 pb-4 pt-0">
                <DivContent className="col-12 col-lg-3">
                    <DivContent className="col-12 mb-4">
                        <Box>
                            <Icon className="FaUserTimes">
                                <FaUserTimes color="#fff" size={24}/>
                            </Icon>
                            <Desc>
                                <Title>Faltam pagar</Title>
                                <Text>7</Text>
                            </Desc>
                        </Box>
                    </DivContent>
                    <DivContent className="col-12  mb-4 mb-lg-0">
                        <Box>
                            <Icon className="FaUsers">
                                <FaUsers color="#fff" size={24}/>
                            </Icon>
                            <Desc>
                                <Title>Pagantes mensais</Title>
                                <Text>18/25</Text>
                            </Desc>
                        </Box>
                    </DivContent>
                </DivContent>
                <DivContent className="col-12 col-lg-9">
                    <AddPay className="mb-4">
                        <Button><FaPlusCircle size={24}/>Cadastrar Pagamento</Button>
                    </AddPay>
                    <GraphSection className="row m-0">
                        <GrahpBox className="col-12 col-lg-6 pl-0  mb-4 mb-lg-0">
                            <GrahpContent>
                                <DivContent>
                                    <h3 style={{ color: "white", textAlign: "center" }}>Resumo Mensal</h3>
                                    <ResponsiveContainer className="mt-4" width="100%" height={300}>
                                    <BarChart data={barData}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" stroke="#fff" />
                                        <YAxis stroke="#fff" />
                                        <Tooltip />
                                        <Legend />
                                        <Bar dataKey="Pagantes" fill="#1976d2" />
                                        <Bar dataKey="NaoPagantes" fill="#e53935" />
                                    </BarChart>
                                    </ResponsiveContainer>
                                </DivContent>
                            </GrahpContent>
                        </GrahpBox>
                        <GrahpBox className="col-12 col-lg-6 pr-0">
                            <GrahpContent>
                                <DivContent>
                                    <h3 style={{ color: "white", textAlign: "center" }}>Financeiro Atual</h3>
                                    <ResponsiveContainer className="mt-4" width="100%" height={300}>
                                        <PieChart>
                                            <Pie
                                            data={pieData}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            label={({ name }) => name}
                                            outerRadius={100}
                                            fill="#8884d8"
                                            dataKey="value"
                                            >
                                            {pieData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                            ))}
                                            </Pie>
                                            <Legend />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </DivContent>
                            </GrahpContent>
                        </GrahpBox>
                    </GraphSection>
                </DivContent>
            </FinanceContent>
        </Section>
    )
}

export default FinanceSection;